module.exports = __webpack_public_path__ + "img/polyana.1eed394d.jpeg";